<template>
  <div>
    <v-card elevation="0" v-if="popoverDataLoading" height="350">
      <v-container  class="loader-popover">
        <v-progress-circular indeterminate size=50 :width="5"></v-progress-circular>
      </v-container>
    </v-card>
    <v-card v-if="!popoverDataLoading" style="min-width:650px;">
      <v-list class="branded-background">
        <v-list-tile avatar>
          <v-icon color="white" class="padding-right">person_add_disabled</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title class="modal-title">
              <span class="text-white text-truncate-popover">Remove Access to {{archiveClass.name}}</span>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-divider></v-divider>
      <v-card elevation="0">
        <v-card-title>
          Are you sure you'd like to remove access to {{archiveClass.name}}?
        </v-card-title>
      </v-card>
      <v-card-actions class="row-space" style="height:56px">
        <v-btn flat class="branded-grey" @click="setDashModal(null)">Cancel</v-btn>
        <div class="row-center">
          <v-btn class="branded-background text-white" @click="removeClassAccess(archiveClass.id)">Remove Access</v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
/* global _ */
import { mapGetters, mapMutations, mapActions } from 'vuex';
import _ from 'lodash';

export default {
  name: 'RemoveAccess',
  props: [ 
    'archiveClass', 
  ], 
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters([
      'popoverDataLoading',
    ]),
    ...mapGetters('instructors', [
      'instructorAjaxing',  
    ]),
  },
  methods: {
    ...mapMutations([
      'setDashModal'
    ]),
    ...mapActions('instructors', [
      'removeClassAccess'  
    ]),
  },
};
</script>
